import { useState } from 'react'
import { Drawer, Anchor } from '@design-systems/canvas-ui'
import { AppBar, Toolbar, Grid, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Icon, {
  ChevronRightIcon,
  ChevronUpIcon,
} from '@design-systems/react-icons'
import TargetPlus from '../common/Icons/TargetPlus'
import { HeaderMegaMenuOptions } from '../../constants/headerMegaMenuOptions'
import appConfig from '../../appConfig'
import applyProps from '../../appConfig/applyConfig'
import styles from './header.module.scss'

const mobileMenuItems = [
  { id: 'home', title: 'Home', href: '/#home' },
  { id: 'get-started', title: 'Get started', hasMegaMenu: true },
  { id: 'grow', title: 'Grow', hasMegaMenu: true },
  {
    id: 'service-providers',
    title: 'Service providers',
    href: '/service-providers',
  },
  { id: 'success-stories', title: 'Success stories', href: '/success-stories' },
  { id: 'events', title: 'Events', href: '/events' },
]

export const MenuDrawer = ({ isOpen, onClose }) => {
  const [expandedMenus, setExpandedMenus] = useState([])

  const toggleMenu = (id) => {
    setExpandedMenus((prev) =>
      prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id],
    )
  }

  const getSubItems = (id) => {
    const megaMenu = HeaderMegaMenuOptions.find(
      (option) => option.headerMainTitle === id,
    )
    return megaMenu?.menuSelection || []
  }

  return (
    <Drawer
      isOpen={isOpen}
      xs={12}
      spacing="none"
      className={styles.mobileDrawer}
    >
      <AppBar
        className={`${styles.headerAppBar} `}
        data-testid="header"
        position="sticky"
      >
        <Toolbar disableGutters>
          <Grid
            container
            className={styles.headerContainer}
            justifyContent="space-between"
            alignItems={'center'}
          >
            {/* Target Plus Logo */}
            <Grid item>
              <IconButton
                disableRipple
                className={styles.headerDisableHoverIconButton}
                href="/"
                size="large"
                aria-label="target plus home"
              >
                <TargetPlus fill="#FFF" />
              </IconButton>
            </Grid>
            <CloseIcon sx={{ width: 32, height: 32 }} onClick={onClose} />
          </Grid>
        </Toolbar>
      </AppBar>
      <nav className={styles.mobileDrawerNav}>
        {mobileMenuItems.map((item) => (
          <div key={item.id} className={`${styles.mobileDrawerItem} hc8-pv-6x`}>
            {item.hasMegaMenu ? (
              <>
                <Anchor
                  onClick={() => toggleMenu(item.id)}
                  className={`${styles.menuDrawerAnchor} hc8-fs-250 hc8-clr-inverse`}
                  aria-expanded={expandedMenus.includes(item.id)}
                  aria-controls={`submenu-${item.id}`}
                >
                  <span>{item.title}</span>
                  <Icon
                    svg={
                      expandedMenus.includes(item.id)
                        ? ChevronUpIcon
                        : ChevronRightIcon
                    }
                    size="inline"
                    className="hc8-pl-1x"
                  />
                </Anchor>
                {expandedMenus.includes(item.id) && (
                  <div id={`submenu-${item.id}`}>
                    {getSubItems(item.id).map((subItem) => (
                      <Anchor
                        key={subItem.name}
                        href={subItem.href}
                        className={styles.mobileDrawerSubItem}
                        onClick={onClose}
                      >
                        <span className={styles.mobileDrawerSubIcon}>
                          {subItem.icon}
                        </span>
                        <div>
                          <div className="hc8-fs-150">
                            <strong>{subItem.name}</strong>
                          </div>
                          <div className="hc8-fs-100">
                            {subItem.description}
                          </div>
                        </div>
                      </Anchor>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <Anchor href={item.href} onClick={onClose}>
                <span className="hc8-fs-250 hc8-clr-inverse">{item.title}</span>
              </Anchor>
            )}
          </div>
        ))}
      </nav>
      <div className={styles.mobileDrawerCTAs}>
        <Anchor
          href={appConfig.sellerUrls.portal}
          className={styles.mobileDrawerSignIn}
        >
          Sign in
        </Anchor>
        <Anchor {...applyProps} className={styles.mobileDrawerApply}>
          Apply now
        </Anchor>
      </div>
    </Drawer>
  )
}
